import { memo } from 'react';

import Image from '@shared/Image';
import type { Hero } from '@shared-types/uefatv.types';
import { competitionFolder, imgBaseUrl } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const HeroTitle = ({ hero }: { hero: Hero }) => {
  const fallbackImg = `${imgBaseUrl}/imgml/uefacom/${competitionFolder}/fallback.jpg`;

  return (
    <div className={styles.heroTitle}>
      {hero.titleImage ? (
        <Image title={hero.title} src={hero.titleImage} fallback={fallbackImg} className={styles.titleImage} />
      ) : (
        <h2>{hero.title}</h2>
      )}
    </div>
  );
};

export default memo(HeroTitle);
